<template>
  <div
      :id="id"
      :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  name: "OmitLineMy",
  props: ["id", "chartsData", 'keyName'],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },
  methods: {
    transferValue(value) {
      if (this.keyName == 'RunSign') {
        return value == 1 ? '开启' : '关闭';
      }

      return value;
    },
    drawLine() {
      let that = this;
      let unit = this.chartsData.unit;
      if (document.getElementById(this.id) == null) {
        return;
      }
      let myChart = this.$echarts.getInstanceByDom(
          document.getElementById(this.id)
      );
      if (!myChart) {
        myChart = this.$echarts.init(document.getElementById(this.id));
      }
      myChart.setOption({}, true);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            let result = params[0].name + "<br>";
            params.forEach(function (item) {
              result += item.marker + " " + that.transferValue(item.value) + ' ' + unit + "</br>";
            });
            return result;
          },
        },
        grid: {
          top: "20px",
          left: "50px",
          right: "1%",
          bottom: "10px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.chartsData.xData,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#CBCBCB",
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#E5E6EB",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#CBCBCB",
            fontSize: 12,
            formatter: (value, index) => {
              if (that['keyName'] === 'RunSign') {
                if (value == 1) {
                  return '开启';
                } else if (value == 0) {
                  return '关闭';
                }
                return '';
              }

              return value;
            }
          },
        },
        series: [
          {
            data: this.chartsData.yData,
            type: "line",
            // smooth: true,
            areaStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(116,160,249,0.15)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(29,63,120,0)", // 0% 处的颜色
                  },
                ],
              },
            },
            lineStyle: {
              color: "#5B8FF9",
              width: 3,
              shadowColor: "rgba(26,117,218,0.17)", //设置折线阴影
              shadowBlur: 5,
              shadowOffsetY: 9,
            },
            itemStyle: {
              color: "#5B8FF9",
              borderColor: "#5B8FF9",
              borderWidth: 5,
            },
            smooth: 0.4,
            emphasis: {
              scale: 1.5,
            },
          },
        ],
      };
      myChart.setOption(option);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
}
</script>

<style scoped>

</style>
